'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useState } from 'react'

import { getQueryClient } from '@/utils/reactQueryUtil'

type Props = {
  children: ReactNode
}

export const ReactQueryProvider = ({ children }: Props) => {
  const [client] = useState(() => getQueryClient())

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
